import './index.css';
import ServicesSubMenu from '../ServicesSubMenu';
import ServicesPricingCTA from '../ServicesPricingCTA';

const consultingServices = [
  {
    title: 'Cloud Consulting',
    description:
      'Plan practical cloud services that reduce infrastructure overhead, scale with demand, and avoid paying for hardware or capacity before the business needs it.',
    highlights: [
      'AWS architecture guidance',
      'Cost-aware hosting and storage choices',
      'Cloud migration and modernization planning',
      'Monitoring, reliability, and operational review',
    ],
  },
  {
    title: 'AI and Business Automation',
    description:
      'Training and consulting on how AI tools, agents, and automation can streamline repetitive work while keeping people in control of business decisions.',
    highlights: [
      'AI workflow training for teams',
      'Agentic automation planning',
      'Redundant task review and prioritization',
      'Modernization roadmaps for small business operations',
    ],
  },
  {
    title: 'IT Services and Modern Business Tools',
    description:
      'General technical help for business systems that need to work together cleanly, from everyday productivity tools to customer communication services.',
    highlights: [
      'Invoicing and business software support',
      'Email service setup and troubleshooting',
      'SMS and customer messaging guidance',
      'Technology planning for more efficient operations',
    ],
  },
];

const ownerSkills = [
  'Cloud-based architecture and development across AWS, Azure, and Google Cloud',
  'AWS services including storage, compute, distributed event-driven architectures, and managed AI services',
  'RESTful API design, backend services, and secure data integrations',
  'Full-stack website and software consulting for individuals and small businesses',
  'Docker, Kubernetes, VMWare and virtualization experience',
  'Project planning, Agile delivery, technical leadership, and technical documentation',
  'Databases including all modern SQL, No-SQL, and document style storage - MSSQL, MySQL, MongoDB, Cosmos DB, DynamoDB, Oracle, and Postgres',
  'Languages and platforms including JavaScript, TypeScript, Python, Node.js, .NET, C#, PHP, HTML, CSS, Linux, Windows, and MacOS',
  'Tutoring, mentorship, maker education, electronics, and IoT experience',
];

const ServicesConsulting = () => {
  return (
    <div className="services-placeholder-page">
      <ServicesSubMenu />
      <section className="services-placeholder-hero">
        <p className="services-placeholder-kicker">Hogcloud Services</p>
        <h1>Tech Consulting</h1>
        <p>
          Practical consulting for small businesses that want modern tools
          without unnecessary complexity. Hogcloud helps connect cloud services,
          AI automation, and everyday IT systems to real business needs.
        </p>
      </section>

      <section className="consulting-services" aria-labelledby="consulting-services-title">
        <div className="consulting-section-header">
          <p className="services-placeholder-kicker">Consulting Services</p>
          <h2 id="consulting-services-title">Modern business support</h2>
        </div>

        <div className="consulting-card-grid">
          {consultingServices.map((service) => (
            <article className="consulting-card" key={service.title}>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul>
                {service.highlights.map((highlight) => (
                  <li key={highlight}>{highlight}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>

      <section className="consulting-owner" aria-labelledby="consulting-owner-title">
        <div>
          <p className="services-placeholder-kicker">Owner Credentials</p>
          <h2 id="consulting-owner-title">Matt Chandler</h2>
          <p>
            Hogcloud is owned by Matt Chandler, a senior cloud architect, engineer and
            technical consultant with experience in cloud architecture,
            full-stack development, business software, technical leadership, and
            maker education. Matt holds an engineering degree from the University of Arkansas, has owned multiple businesses, and brings more than 25 years of technology experience, including work with Fortune 50 companies. He is certified in AWS cloud architecture and AI architecture.
          </p>
        </div>

        <div className="consulting-skill-list" aria-label="Matt Chandler skills and services">
          {ownerSkills.map((skill) => (
            <span key={skill}>{skill}</span>
          ))}
        </div>

        <a className="consulting-owner-link" href="https://mattchandler.us" target="_blank" rel="noreferrer">
          Visit mattchandler.us
        </a>
      </section>

      <ServicesPricingCTA />
    </div>
  );
};

export default ServicesConsulting;
